import type { KuxDms, LocalVqSettingItem } from '@kaltura-ott/tvpil';
import { observable } from 'mobx';
import { singleton } from 'tsyringe';

@singleton()
export class DmsStore {
  @observable dms!: KuxDms;

  private get sortedVideoQualitySettings() {
    return Object.entries(this.dms.bitrateLimitationManagement.localVqSettings).sort(
      ([, a], [, b]) => b['top_range_bitrate'] - a['top_range_bitrate'],
    );
  }

  public get highestBitrate() {
    const [, highestQuality] = this.sortedVideoQualitySettings.shift() ?? [];

    return highestQuality?.['top_range_bitrate'];
  }

  public get videoQualitySettings(): LocalVqSettingItem[] {
    const settings = this.sortedVideoQualitySettings;

    settings.shift();

    return settings;
  }
}
